/**
 * src/three/targetLabel.js
 * สติกเกอร์เป้า — แผ่นติดหน้าอิฐ (ไม่ใช่ sprite ลอย)
 */
import * as THREE from 'three';
import { T3 } from './config.js';

export function createTargetSprite(_label) {
  const size = 128;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = 'rgba(20, 8, 6, 0.55)';
  ctx.beginPath();
  ctx.ellipse(64, 64, 52, 52, 0, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = '#e8a878';
  ctx.beginPath();
  ctx.arc(64, 64, 32, 0, Math.PI * 2);
  ctx.fill();

  ctx.strokeStyle = '#2a1010';
  ctx.lineWidth = 4;
  ctx.lineCap = 'round';
  ctx.beginPath();
  ctx.moveTo(46, 52);
  ctx.lineTo(58, 57);
  ctx.moveTo(82, 52);
  ctx.lineTo(70, 57);
  ctx.stroke();

  ctx.fillStyle = '#1a0808';
  ctx.beginPath();
  ctx.arc(53, 64, 4.5, 0, Math.PI * 2);
  ctx.arc(75, 64, 4.5, 0, Math.PI * 2);
  ctx.fill();

  ctx.strokeStyle = '#5a1010';
  ctx.lineWidth = 3;
  ctx.beginPath();
  ctx.arc(64, 76, 11, 0.15 * Math.PI, 0.85 * Math.PI);
  ctx.stroke();

  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.needsUpdate = true;

  const face = Math.min(T3.BRICK_W, T3.BRICK_H) * 0.72;
  const mat = new THREE.MeshBasicMaterial({
    map: tex,
    transparent: true,
    depthWrite: false,
    fog: false,
    toneMapped: false,
  });
  const mesh = new THREE.Mesh(new THREE.PlaneGeometry(face, face), mat);
  // แปะติดหน้าอิฐพอดี ไม่ลอย
  mesh.position.set(0, 0, T3.BRICK_D * 0.5 + 0.008);
  mesh.renderOrder = 8;
  mesh.raycast = () => {};
  return mesh;
}

/** คำสลายตอนเป้าพัง — ยังเป็น sprite ได้ (เอฟเฟกต์ชั่วคราว) */
export function createDissolveSprite(label) {
  const canvas = document.createElement('canvas');
  canvas.width = 256;
  canvas.height = 96;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, 256, 96);
  ctx.font = 'bold 32px "Kanit", sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.lineWidth = 6;
  ctx.strokeStyle = '#100604';
  ctx.fillStyle = '#ffb080';
  const text = String(label || '').slice(0, 12);
  ctx.strokeText(text, 128, 48);
  ctx.fillText(text, 128, 48);

  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  const spr = new THREE.Sprite(new THREE.SpriteMaterial({
    map: tex,
    transparent: true,
    depthTest: false,
    depthWrite: false,
    fog: false,
    opacity: 1,
  }));
  spr.scale.set(2.1, 0.78, 1);
  spr.renderOrder = 40;
  return spr;
}
